<template>
  <div>
    <div id="container"></div>
  </div>
</template>
 
<script>

import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: {},
  props:{
       serviceProviderList:{ //
          type:Array, 
          default:[]
      }
  },
  data() {
    return {
      map: null,
      infoLists: [],
      title:'',
      pos_icon : [],
      pos_marker : [],
      icon : [],
      marker : [],
      driving:null,
      anchor : [
        'bottom-left',
        'bottom-center',
        'bottom-right',
        'middle-left',
        'center',
        'middle-right',
        'top-left',
        'top-center',
        'top-right'
    ],
    currentSelect:{},
    startDriving: [113.7550342, 23.0361437],
    endDriving:{},
    hideDriving: false 
    };
  },
  created() {
    this.initMap();
    this.title = ''

    //触发 地图自定义的信息窗体内绑定的事件
   window.getNavigation=()=>{
      this.getDriving()
    }
  },
  watch: {
    serviceProviderList: {
      handler (val, oldval) {
        console.log('serviceProviderList取到新值',val)
         this.map.clearMap() //清除地图全部覆盖物
        if( this.serviceProviderList && this.serviceProviderList.length > 0 ){
            this.serviceProviderList.forEach(item=>{
                 this.SimpleMarker(item)
            })
        }
      }
    },
    
  },
  methods: {
    initMap() {
      AMapLoader.load({
        // 83c91f4e8b713c8b8d2432d5d14165f1 公司
        key: "83c91f4e8b713c8b8d2432d5d14165f1", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        AMapUI: {
          version: "1.1",
          plugins: ["overlay/SimpleMarker", "overlay/SimpleInfoWindow"],
        },
        plugins: ["AMap.Marker", "AMap.ToolBar", "AMap.Driving","AMap.Geolocation","AMap.ControlBar"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            //设置地图容器id
            // mapStyle: "amap://styles/9ad88e592222a6f99a56e64bfb0dfa46", //设置地图的显示样式
            viewMode: "3D", //是否为3D地图模式
            zoom: 13, //初始化地图级别
            center: [113.7550342, 23.0361437], //初始化地图中心点位置
          });
        // this.map.setMapStyle('amap://styles/blue'); //设置地图的显示样式
        this.map.setMapStyle('amap://styles/9ad88e592222a6f99a56e64bfb0dfa46'); //设置地图的显示样式
        let _this = this
        AMapUI.loadUI(['control/BasicControl'], function(BasicControl) {
        //添加一个缩放控件
        _this.map.addControl(new BasicControl.Zoom({
            position: 'lb',
            theme:'control' 
           }));
        });
          _this.map.addControl(new AMap.ControlBar({
            position: {
                right: '130px',
                bottom: '270px'
            },
            offset:[100,100],
             theme:'compass',
            showControlButton: true,  // 是否显示倾斜、旋转按钮。默认为 true
        }));


        })
        .catch((e) => {
          console.log("创建地图失败", e);
        });
    },
    getDriving(){
      let _this = this
          if(_this.endDriving.longitude_latitude.length === 1){
            
            _this.$emit('endDriving',)// 通知父组件显示取消导航按键显示

            _this.map.clearMap() //清除地图全部覆盖物
            _this.driving = new AMap.Driving({
              map: _this.map,
              policy: AMap.DrivingPolicy.LEAST_TIME
              }); 
              // 根据起终点经纬度规划驾车导航路线
             _this.driving.search(_this.startDriving, _this.endDriving.longitude_latitude[0], function(status, result) {
              // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
              if (status === 'complete') {
                  console.log('绘制驾车路线完成')
              } else {
                console.log('获取驾车数据失败：',result)
              }
            });
            _this.hideDriving = true
            _this.SimpleMarker(this.endDriving) // 加载导航目标的点标记

      }else{
        console.log('获取失败：')
      }
    },
    // 
    cancelDriving(){
      let _this = this
        _this.map.clearMap()
        _this.hideDriving = false
        // 清除规划路径
        if(_this.driving){
          _this.driving.clear()
          if(_this.driving.render){
            _this.driving.render.clear()
          }
        }
        // 重新加载全部的点标记
        if( _this.serviceProviderList && _this.serviceProviderList.length > 0 ){
            _this.serviceProviderList.forEach(item=>{
                 _this.SimpleMarker(item)

            })
        }

    },
    // 服务商列表操作
    customWindow(item){
      if(this.endDriving.userDto){
        if(this.endDriving.userDto.userId !== item.userDto.userId  ){
          this.cancelDriving()
          this.endDriving = item 
      }
      }else{
        this.endDriving = item 
      }
      
      this.infoLists.forEach(v => {
        if(v.id === item.userDto.userId) {
          v.infoWindow.open(this.map, this.marker[item.longitude_latitude[0]].getPosition());
           
          this.map.panTo(item.longitude_latitude[0]) // 地图平移
         
        }
       
       
      })
       
    },
    SimpleMarker(item) {
      let _this = this;
      // 创建一个 Icon
        _this.pos_icon[item.longitude_latitude[0]] = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(33, 31),
            // 图标的取图地址
            image: 'https://dx-oss.oss-cn-shenzhen.aliyuncs.com/largeScreen/location_icon.png',
            // 图标所用图片大小
            imageSize: new AMap.Size(33, 31),
        });
        // var labelContent = "<div class='labelContent'>anchor:"+_this.anchor[arr]+"</div>"
        // 将 Icon 传入 marker
        _this.pos_marker[item.longitude_latitude[0]] = new AMap.Marker({
            // position: [item.serviceProviderDto.providerPositionDto.longitude,item.serviceProviderDto.providerPositionDto.latitude],
            position: item.longitude_latitude[0],
            icon: _this.pos_icon[item.longitude_latitude[0]],
            anchor: 'center', //设置锚点
            offset: new AMap.Pixel(0,0) //设置偏移量
        });
        _this.map.add(_this.pos_marker[item.longitude_latitude[0]]);
        _this.icon[item.longitude_latitude[0]] = new AMap.Icon({
            // 图标尺寸
            size: new AMap.Size(50, 50),
            // 图标的取图地址
            image: item.fileUrl,
            // 图标所用图片大小
            imageSize: new AMap.Size(50, 50),
        });
        // 将 Icon 传入 marker
        var labelOffset = new AMap.Pixel(-25,-28);
        _this.marker[item.longitude_latitude[0]] = new AMap.Marker({
            // position: [item.serviceProviderDto.providerPositionDto.longitude,item.serviceProviderDto.providerPositionDto.latitude],
            position: item.longitude_latitude[0],
            icon: _this.icon[item.longitude_latitude[0]],
            anchor: _this.anchor[item.longitude_latitude[0]], //设置锚点
            offset: new AMap.Pixel(-25,-70), //设置偏移量
            label: {
                // content: labelContent,
                offset: labelOffset
            }
        });
        _this.map.add(_this.marker[item.longitude_latitude[0]]);
        // 自定义窗体
        // 在线、离线图标
        let state_img = {
           icon: 'on-state-img',
           name:'在线',
           textClass:'on-state-text'
        }
        if(item.userDto.isOnline){
            state_img.icon = 'on-state-img'
            state_img.textClass= 'on-state-text'
            state_img.name = '在线'
        }else{
            state_img.icon = 'off-state-img'
            state_img.textClass= 'off-state-text'
             state_img.name = '离线'
        }
        let content = []
        content.push(`<div class='user'><div class='user-left'><img class='img' src="${item.fileUrl}"><div class='user-name'>${ item.receiveNick }</div></div><div class="img-icon"><div class='${state_img.icon}'></div><span class='${state_img.textClass}'>${state_img.name}</span></div></div>`);
        content.push(`<div class='service-distance'><div class='service'><span class='service-times'>${item.time}<span class='small-text'>次</span></span><span class='service-text'>服务次数</span></div><div class='service'><span class='service-times'>${item.distance} <span class='small-text'>KM</span></span><span class='service-text'>距离你</span></div> </div>`);
        if( _this.hideDriving === false ){
            content.push(`<div class="navigation" onclick="getNavigation()"><span class='navigation-img'></span> <span class="navigation-text">导航</span></div>`);
        }
        var infoWindow = new AMap.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: _this.createInfoWindow(_this.title, content.join("<br/>")),
        offset: new AMap.Pixel(15, -80)
        });
          //鼠标点击marker弹出自定义的信息窗体
        _this.infoLists.push({
          id: item.userDto.userId,
          infoWindow: infoWindow
        })
        _this.marker[item.longitude_latitude[0]].on('click', function () {
          // infoWindow.open(_this.map, _this.marker[item.longitude_latitude[0]].getPosition());
          _this.endDriving = item // 
          _this.customWindow(item)
        });
       
    },
    
    createInfoWindow(title, content){
        let _this = this
        var info = document.createElement("div");
        info.className = "custom-info input-card content-window-card";

        //可以通过下面的方式修改自定义窗体的宽高
        info.style.width = "284px";
        info.style.height = "204px";
        // 定义顶部标题
        var top = document.createElement("div");
        var titleD = document.createElement("div");
        var closeX = document.createElement("img");
        top.className = "info-top";
        titleD.innerHTML = title;
        closeX.src = "https://webapi.amap.com/images/close2.gif";
        closeX.onclick = closeInfoWindow;
        top.appendChild(titleD);
        top.appendChild(closeX);
        info.appendChild(top);

        // 定义中部内容
        // 
        var middle = document.createElement("div");
        middle.className = "info-middle";
        middle.innerHTML = content;
        // navigation.onclick = Navigation
        // info.appendChild(navigation)
        info.appendChild(middle);
        return info;
         //关闭信息窗体
        function closeInfoWindow() {
            _this.map.clearInfoWindow();
        }
        
    },
    
    SimpleMarker2(arr) {
      let _this = this;
      let marker = new AMapUI.SimpleMarker({
        //自定义图标节点(img)的属性
        iconStyle: {
          src: "https://dx-oss.oss-cn-shenzhen.aliyuncs.com/largeScreen/location_icon.png",
          style: {
            width: "33px",
            height: "31px",
          },
        },
       
        //设置基点偏移
        offset: new AMap.Pixel(-16.5, -25),
        map: _this.map,
        showPositionPoint: true,
        position: arr,
        zIndex: 200,
         label: { content: "<div class='infos'>张三</div>"},
        anchor: 'center', //设置锚点
      });
      var infoWindow = new AMap.InfoWindow({
        isCustom: true,  //使用自定义窗体
        content: _this.createInfoWindow(_this.title, _this.content.join("<br class='br'/>")),
        offset: new AMap.Pixel(16, -45)
        });
         //鼠标点击marker弹出自定义的信息窗体
        marker.on('click', function () {
        infoWindow.open(_this.map, marker.getPosition());
    });
    }
  },
  computed: {},
};
</script>
<style  scoped>
#container {
  width: 1920px;
  height: 1080px;
}
.my-desc {
    background-color: aliceblue;
}
</style>
<style>
.content-window-card {
            position: relative;
            box-shadow: none;
            bottom: 0;
            left: 0;
            width: auto;
            padding: 0;
        }

        .content-window-card p {
            height: 2rem;
            
        }

        div.info-middle {
            width: 284px;
            height: 204px;
            font-size: 12px;
            padding: 20px 22px 0px 27px;
            line-height: 20px;
            background-image: url('../assets/dd/dd-bg49.png');
            background-repeat: no-repeat;
            box-sizing: border-box;
        }

        div.info-bottom {
            height: 0px;
            width: 100%;
            clear: both;
            text-align: center;
        }

        div.info-bottom img {
            position: relative;
            z-index: 104;
        }

        span {
            margin-left: 5px;
            font-size: 11px;
        }
        div.info-middle .user{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center
        }
        div.info-middle .user-left{
            display: flex;
            align-items: center;
        }
        div.info-middle .img {
            width: 50px;
            height: 50px;
            background-color: aqua;
            border-radius: 50%;
        }
        div.info-middle .user-name{
            color: #fff;
            font-size: 16px;
            margin-left: 11px;
        }
        div.info-middle .img-icon{
            display: flex;
            align-items: center;
        }
       div.info-middle .on-state-img{
           width: 15px;
           height: 15px;
           border-radius: 50%;
           background-image: url("../assets/dd/dd-icon04.png");
            background-repeat: no-repeat;
            background-position: center;
        }  
        div.info-middle .off-state-img{
           width: 25px;
           height: 25px;
           border-radius: 12px;
           background-image: url("../assets/dd/dd-off-icon.png");
            background-repeat: no-repeat;
            background-position: center;
        }  
        div.info-middle .on-state-text{
           color: #00E6D2;
           font-size: 14px;
        } 
        div.info-middle .off-state-text{
           color: #F83B44;
           font-size: 14px;
        } 
        /* 服务-----距离 */
      .info-top img{
        width: 15px;
        height: 15px;
        position: absolute;
        right: 10px;
        top: 10px;
      }
       div.info-middle .service-distance{
            display: flex;
            align-items: center;
            justify-content: space-around;
        }
       div.info-middle .service{
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
        }
       div.info-middle .service-times{
            font-size: 30px;
            color: #fff;
        }
       div.info-middle .service-text{
            margin-top: 10px;
            font-size: 12px;
            color: #265F94;
        }
        div.info-middle .small-text{
          font-size: 18px;
        }
        /* navigation */
        div.info-middle .navigation{
          /* width: 100%; */
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          /* background-color: #0D2342; */
        }
        div.info-middle .navigation-img{
          width: 16px;
          height: 16px;
          background-image: url("../assets/dd/dd-icon09.png");
          background-repeat: no-repeat;
        }
        div.info-middle .navigation-text{
          color: #fff;
          margin-left: 10px;
          font-size: 14px;
        }


          #panel {
            position: fixed;
            background-color: white;
            max-height: 90%;
            overflow-y: auto;
            top: 10px;
            right: 10px;
            width: 280px;
        }
        #panel .amap-call {
            background-color: #009cf9;
            border-top-left-radius: 4px;
   	        border-top-right-radius: 4px;
        }
        #panel .amap-lib-driving {
	        border-bottom-left-radius: 4px;
   	        border-bottom-right-radius: 4px;
            overflow: hidden;
        }
        /* 地图控件 */
        /* 缩放 */
        .amap-ui-control-theme-control{
          width: 75px;
          height: 34px;
         position: absolute !important;
         left: 455px !important;
         bottom: 270px !important;

        }
       .amap-ui-control-theme-control .amap-ui-control-zoom{
          width: 75px !important;
          height: 34px;
          display: flex;
          justify-content: space-between;
          border: none;
          
        }
      .amap-ui-control-theme-control .amap-ui-control-zoom .zoom-btn{
        width: 37px;
        background-color: #102C59;
        color: #00F5F7;
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
        border-radius: 4px;
        
      }
      /* 罗盘 */
        /* .amap-luopan{
          background-color: red !important;
        }
        .amap-luopan .amap-compass{
          background-color: red;
        } */
        /* .amap-luopan .amap-compass .amap-pointers{
          width: 20px;
          height: 30px;
        } */
</style>
 


// WEBPACK FOOTER //
// src/components/MapContainer.vue